import type { NavItemProps } from '~/utils/nav'

type MaybeProps = MaybeRefOrGetter<Pick<NavItemProps, 'to' | 'considerChildrenActive'> | undefined | null>

export function useIsActiveRoute(props: MaybeProps): ComputedRef<boolean>
export function useIsActiveRoute(): (props: MaybeProps) => boolean
export function useIsActiveRoute(props?: MaybeProps): ComputedRef<boolean> | ((props: MaybeProps) => boolean) {
  const router = useRouter()

  function isActive(props: MaybeProps) {
    const p = toValue(props)
    const route = p?.to

    if (!route) {
      return false
    }

    const currentRoute = router.currentRoute.value
    const resolvedRoute = router.resolve(route)
    const isSelfActive = resolvedRoute.fullPath === currentRoute.fullPath
    if (!p?.considerChildrenActive) {
      return isSelfActive
    }

    const children = resolvedRoute.matched.flatMap(r => r.children)

    return isSelfActive || children.some(childRoute => childRoute.name === currentRoute.name)
  }

  if (props) {
    return computed(() => isActive(props))
  }

  return isActive
}
